import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import { Card, CardContent } from '../components/ui/Card';
import { Bell, Check, Inbox } from 'lucide-react';
import Button from '../components/ui/Button';

export default function NotificationsPage() {
  const queryClient = useQueryClient();
  const { data } = useQuery({ queryKey: ['notifications'], queryFn: () => api.get('/notifications').then(r => r.data) });
  const markAll = useMutation({ mutationFn: () => api.patch('/notifications/read-all'), onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }) });
  const notifications = data?.data || [];

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div className="d-page-header">
          <h1 className="text-2xl font-bold text-white">Notifications</h1>
          <p className="text-slate-400 mt-1">Stay updated on your account.</p>
        </div>
        <Button variant="ghost" size="sm" onClick={() => markAll.mutate()}>
          <Check className="w-4 h-4" />Mark all read
        </Button>
      </div>

      <Card>
        <CardContent>
          {notifications.length === 0 ? (
            <div className="flex flex-col items-center py-16">
              <div className="w-16 h-16 rounded-2xl bg-white/[0.04] border border-white/[0.06] flex items-center justify-center mb-4">
                <Inbox className="w-7 h-7 text-slate-500" />
              </div>
              <p className="text-base font-semibold text-white">No notifications</p>
              <p className="text-sm text-slate-400 mt-1">You're all caught up.</p>
            </div>
          ) : (
            <div className="divide-y divide-white/[0.04]">
              {notifications.map((n: any) => (
                <div key={n.id} className={`py-4 ${!n.isRead ? 'bg-primary-500/[0.03]' : ''}`}>
                  <div className="flex items-start gap-3">
                    {!n.isRead && <div className="w-2 h-2 rounded-full bg-primary-500 mt-2 shrink-0" />}
                    <div className={!n.isRead ? '' : 'ml-5'}>
                      <p className="text-sm font-medium text-white">{n.title}</p>
                      <p className="text-sm text-slate-400 mt-0.5">{n.message}</p>
                      <p className="text-xs text-slate-500 mt-1.5">{new Date(n.createdAt).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
